import * as actionTypes from '../actionTypes'
import api from '../api'
import { loadLocale } from './i18n'

const authenticate = async (dispatch, authPayload) => {
	let locale
	try {
		let response = await api.authenticate(authPayload)
		const { accessToken } = response
		const jwtPayload = await api.passport.verifyJWT(response.accessToken)
		const user = await api.service('users').get(jwtPayload.userId)
		const roles = jwtPayload.roles
		api.set('user', user)
		locale = user.locale
		await dispatch(loginCompleted(accessToken, user.name, roles))

		try {
			const lbbId = 'LBB', nafaId = 'NAFA'
			const fleetTypes = [
				// { id: 'NAFA', name: 'NAFA' },
				{ id: 'LBB', name: 'LBB' },
			]
			dispatch(initial_dropdown(fleetTypes, 'accountTypeOptions'))
			dispatch(setLbbAndNafaAction(lbbId, nafaId))

			const countryTypeResponse = await api.service('countries').find({
				query: {
					id: { $in: ['USA', 'CAN'] }
				}
			})
			dispatch(initial_dropdown(countryTypeResponse.data, 'countryTypeOptions'))

			const inboundProgramAccountTypeResponse = await api.service('inboundProgramAccountTypes').find()
			dispatch(initial_dropdown(inboundProgramAccountTypeResponse.data, 'inboundProgramAccountTypes'))

			const assetValidationTypesResponse = await api.service('assetValidationTypes').find() 
			dispatch(initial_dropdown(assetValidationTypesResponse.data, 'assetValidationTypes'))

			const vehicleTypesResponse = await api.service('vehicleTypes').find({query: {$limit:200}}) 
			dispatch(initial_dropdown(vehicleTypesResponse.data, 'vehicleTypes'))

			const axleTypeResponse = await api.service('axleTypes').find()
			dispatch(initial_dropdown(axleTypeResponse.data, 'axleTypeOptions'))

			dispatch(initial_dropdown([{ id: 'Await Verbal Instruction', name: 'Await Verbal Instruction' }], 'requiredActivityTypeOptions'))

			dispatch(initial_dropdown([{ id: false, name: 'New' }, { id: true, name: 'Retread' }], 'tireTypeOptions'))

			dispatch(initial_dropdown([{ id: true, name: 'Before' }, { id: false, name: 'After' }], 'beforeAfterOptions'))

			const contactTypeResponse = await api.service('contactTypes').find()
			dispatch(initial_dropdown(contactTypeResponse.data, 'contactTypes'))

			const tireApplicationResponse = await api.service('tireApplicationList').find({ query: { fleetLocationId: null, $limit: 200, 'applicationId[$lt]': 100 } })
			dispatch(initial_dropdown(tireApplicationResponse.data, 'tireApplicationTypeOptions'))

			const tireBrandResponse = await api.service('tireBrands').find({ query: { isActive: { $eq: true }, $limit: 200 } })
			const priorityTireBrands = tireBrandResponse.data.filter(item => item.priority !== null).sort((a, b) => a - b)
			const otherTireBrands = tireBrandResponse.data.filter(item => item.priority === null).sort((a, b) => {return a.name.localeCompare(b.name)})
			const tireBrandTypeOptions = priorityTireBrands.concat(otherTireBrands)
			dispatch(initial_dropdown(tireBrandTypeOptions, 'tireBrandTypeOptions'))
			
			const tireSizeResponse = await api.service('tireSizes').find({ query: { isActive: { $eq: true }, $limit: 500 } })
			const priorityTireSizes = tireSizeResponse.data.filter(item => item.priority !== null).sort((a, b) => a.priority - b.priority)
			const otherTireSizes = tireSizeResponse.data.filter(item => item.priority === null).sort((a, b) => {
				if (a.sortOrder > b.sortOrder) return 1
				if (a.sortOrder < b.sortOrder) return -1

				return a.name.localeCompare(b.name)
			})
			const tireSizeTypeOptions = priorityTireSizes.concat(otherTireSizes)
			dispatch(initial_dropdown(tireSizeTypeOptions, 'tireSizeTypeOptions'))

			const tireTreadResponse = await api.service('tireTreads').find({ query: { isActive: { $eq: true },  $limit: 3000 } })
			const priorityTireTreads = tireTreadResponse.data.filter(item => item.priority !== null).sort((a, b) => a - b)
			const otherTireTreads = tireTreadResponse.data.filter(item => item.priority === null).sort((a, b) => { return a.name.localeCompare(b.name) })
			const tireTreadTypeOptions = priorityTireTreads.concat(otherTireTreads)
			dispatch(initial_dropdown(tireTreadTypeOptions, 'tireTreadTypeOptions'))

			const tireLoadRangeResponse = await api.service('tireLoadRanges').find({ query: { isActive: { $eq: true }, isGeneric: { $eq: false }, $limit: 200 } })
			const loadRangeTypeOptions = tireLoadRangeResponse.data.sort((a, b) => a.name.localeCompare(b.name))
			dispatch(initial_dropdown(loadRangeTypeOptions, 'loadRangeTypeOptions'))

			const wheelDiameterResponse = await api.service('wheelDiameters').find({ query: { isActive: { $eq: true }, $limit: 200 } })
			const wheelDiameterOptions = wheelDiameterResponse.data.sort((a, b) => a.name.localeCompare(b.name))
			dispatch(initial_dropdown(wheelDiameterOptions, 'wheelDiameterOptions'))

			//@TODO offsetLookuptable
			dispatch(initial_dropdown([{ id: -1, name: 'No Selection' }, { id: 0, name: '0' }, { id: 1, name: '1' }, { id: 2, name: '2' }], 'wheelOffsetOptions'))

			const wheelMaterialTypesResponse = await api.service('wheelMaterials').find({ query: { isActive: { $eq: true }, $limit: 200 } })
			const wheelMaterialTypeOptions = wheelMaterialTypesResponse.data.sort((a, b) => a.name.localeCompare(b.name))
			dispatch(initial_dropdown(wheelMaterialTypeOptions, 'wheelMaterialTypeOptions'))

			const otherAccountTypesResponse = await api.service('otherAccountTypes').find({ query: { isActive: { $eq: true }, $limit: 200 } })
			const otherAccountTypesOptions = otherAccountTypesResponse.data.sort((a, b) => a.name.localeCompare(b.name))
			dispatch(initial_dropdown(otherAccountTypesOptions, 'otherAccountTypes'))

			const wheelTypesResponse = await api.service('wheelTypes').find({ query: { isActive: { $eq: true },  $limit: 200 } })
			const wheelTypeOptions = wheelTypesResponse.data.sort((a, b) => a.name.localeCompare(b.name))
			dispatch(initial_dropdown(wheelTypeOptions, 'wheelTypeOptions'))

			const authorizationPreferencesResponse = await api.service('authorizationPreferences').find({ query: { $limit: 200 } })
			dispatch(initial_dropdown(authorizationPreferencesResponse.data, 'driverAuthorizationTypeOptions'))

			const tireDispositionsResponse = await api.service('tireDispositions').find({ query: { isActive: { $eq: true }, $limit: 200 } })
			dispatch(initial_dropdown(tireDispositionsResponse.data, 'dispositionOfOffTireTypeOptions'))

			// response = await api.service('creditCardRules').find({ query: { $limit: 200 } })
			// dispatch(initial_dropdown(response.data, 'creditCardOptions'))
		} catch (error) {
			throw error
		}
	} catch (error) {
		throw error
	} finally {
		await dispatch(loadLocale(locale))
	}
}

export const autoLogin = () => {
	return async dispatch => {
		try {
			await authenticate(dispatch)
		} catch (error) {
			//Doesn't really matter here.
		}
	}
}

export const logout = () => {
	return async dispatch => {
		api.logout()
		await dispatch(loggedOut())
	}
}

export const initial_dropdown = (dropdown, field) => ({
	type: actionTypes.LOADED_INITIAL_DROPDOWN,
	dropdown: dropdown,
	field: field
})

const setLbbAndNafaAction = (lbbId, nafaId) => ({
	type: actionTypes.ACCOUNT_IDS,
	lbbId: lbbId,
	nafaId: nafaId
})

export const login = (username, password) => {
	return async (dispatch, getState) => {
		if (!getState().login.isLoading) {
			await dispatch(loginStarted(username, password))
			try {
				await authenticate(dispatch, {
					strategy: 'local',
					username,
					password
				})
			} catch (error) {
				await dispatch(loginFailed(error))
			}
		}
	}
}

export const loggedOut = () => ({
	type: actionTypes.LOGIN_LOGOUT
})

export const loginStarted = (username, password) => ({
	type: actionTypes.LOGIN_STARTED,
	username,
	password
})

export const loginCompleted = (accessToken, username, roles) => ({
	type: actionTypes.LOGIN_COMPLETED,
	accessToken,
	username,
	roles
})

export const loginFailed = error => ({
	type: actionTypes.LOGIN_FAILED,
	error
})


// WEBPACK FOOTER //
// ./src/actions/login.js